import React from 'react'
import styled from '@emotion/styled'
import { BlockMonogram } from '../svgs/BlockMonogram'
import { BDCLogo } from '../svgs/BDCLogo'
import { Link } from '@jelly/ui'
import { useTheme } from 'emotion-theming'

const BdcLogoContainer = styled(Link)`
	cursor: pointer;
	display: block;
	height: 40px;
	margin: 10px 0;
	width: 250px;
`
const BlockMonogramContainer = styled(Link)`
	cursor: pointer;
	display: block;
	max-width: 75px;
	width: 100%;
	height: 90px;
`

export function FooterLogoBdc() {
	const {
		colors: { secondary },
	} = useTheme()
	return (
		<>
			<BlockMonogramContainer href="/">
				<BlockMonogram color={secondary} />
			</BlockMonogramContainer>
			<BdcLogoContainer href="/">
				<BDCLogo />
			</BdcLogoContainer>
		</>
	)
}
